import React, { useEffect, useState } from "react";
import PageTitle from "../../Common/PageTitle"
import Swal from "sweetalert2";
import {
  Box, Container, Grid, GridItem, Heading, Text, Image, Avatar, HStack, VStack, Badge,
  Button, IconButton, Divider, Wrap, WrapItem, TagLabel, Link, Input, Textarea, useColorModeValue,
  Accordion, AccordionItem, AccordionButton, AccordionIcon, AccordionPanel
} from '@chakra-ui/react';
import { FaTwitter, FaLinkedin, FaFacebook, FaShareAlt } from 'react-icons/fa';
import { FaWhatsapp } from "react-icons/fa6";
import { FiCalendar, FiClock, FiTag } from 'react-icons/fi';
import { useLocation, useParams } from "react-router-dom";
import moment from "moment"
import { Helmet } from 'react-helmet-async';

const BlogDetail = ({ post = null }) => {
  const location = useLocation();
  const params = useParams();
  const blogData = location.state;
  const [finalHTML, setFinalHTML] = useState("");

  useEffect(() => {
    if (blogData?.long_des && blogData?.toc?.length > 0) {

      const parser = new DOMParser();
      const doc = parser.parseFromString(blogData.long_des, "text/html");

      const headings = doc.querySelectorAll("h1, h2, h3, h4, h5, h6");

      blogData.toc.forEach((item) => {
        let match = Array.from(headings).find(h =>
          h.innerText.trim().includes(item.text.replace(/^\d+\.\s*/, "").trim())
        );

        if (match) {
          match.id = item.anchor;   // ✔ Add anchor ID
        }
      });

      setFinalHTML(doc.body.innerHTML);
    }
  }, [blogData]);

  const mock = {
    related: [
      { id: 1, title: 'What is MERN Stack? Complete Beginner Guide' },
      { id: 2, title: 'How to Improve SEO in 2025' },
      { id: 3, title: 'How to Start a Career in Web Development' },
      { id: 4, title: 'Top Node.js Features Every Developer Must Know' },
      { id: 5, title: 'Why UI/UX Design is Important for Websites' },
    ],
  };

  const data = post || mock;
  const bg = useColorModeValue('white', 'gray.800');
  const muted = useColorModeValue('gray.600', 'gray.400');

  console.log(blogData, 'blogData')
  return (
    <>

      <Helmet>
        <title>{blogData.title} | OneBigBit Technologies Private Limited</title>
        <meta name="description" content={blogData.meta_description} />
        <meta name="keywords" content={blogData.keywords?.map((d) => d + ",")} />
        <meta property="og:title" content={blogData.og_title} />
        <meta property="og:description" content={blogData.og_description} />
        <meta property="og:type" content={blogData.og_type} />
        <meta property="og:url" content={blogData.og_url} />
        <meta property="og:image" content={blogData.og_image} />
        <link rel="canonical" href={blogData.canonical_url} />
        <meta name="author" content="OneBigBit Technology" />
        <script type="application/ld+json">
          {blogData?.schema_markup}
        </script>
      </Helmet>
      <div className="slidersection_here ">
        <div className="pageheader bg-blue"></div>
        <PageTitle
          title={params.name}
          prevtitle="Blogs"
          desc={blogData.short_des}
          bimg="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTd8pfXpd_dCEAPzLONZ7dnX7p7kCM-LgwJiA&s"
          page={params.name}
        />
        <section>

          <div className="container about_page" style={{ marginBottom: "-120px" }}>

            {blogData &&
              <Box bg={'gray.50'} py={{ base: 6, md: 12 }} className="mt-5">
                <Container maxW="7xl">
                  <Grid
                    templateColumns={{ base: '1fr', md: '3fr 1fr' }}
                    gap={{ base: 6, md: 10 }}
                  >

                    {/* MAIN CONTENT */}
                    <GridItem>
                      <Box bg={bg} rounded="xl" overflow="hidden" shadow="sm">
                        <Image
                          src={blogData.image_url}
                          alt={blogData.title}
                          objectFit="cover"
                          w="100%"
                          h={{ base: '200px', md: '380px' }}
                        />

                        <Box p={{ base: 4, md: 8 }}>

                          <Heading as="h3" size={{ base: "md", md: "lg" }} mb={2}>
                            {blogData.title}
                          </Heading>
                          <Box color={muted} fontSize="md" mt={3}>

                          </Box>
                          <Divider my={3} />
                          <Box bg={bg} p={4} rounded="lg" shadow="sm">
                            <Heading size="sm" mb={3}>Table of Content</Heading>
                            <VStack align={'stretch'} spacing={2} maxH={'300px'} p={10} background={'gray.100'} overflowY={'auto'}>
                              {blogData?.toc?.map((data, idx) => (
                                <Box
                                  key={idx}

                                  cursor={'pointer'}
                                  fontSize={'sm'}
                                  color={'gray.700'}
                                  py={0} fontWeight={'700'}
                                  _hover={{ color: "blue.600" }}
                                  onClick={() => {
                                    const el = document.getElementById(data.anchor);
                                    el?.scrollIntoView({ behavior: "smooth", block: "start" });
                                  }}
                                >
                                  {data.text}
                                </Box>
                              ))}
                            </VStack>
                          </Box>
                          <Box color={muted} fontSize="md" mt={3}>
                            <div dangerouslySetInnerHTML={{ __html: finalHTML }} />
                          </Box>


                          <Divider my={6} />

                          {/*FAQ SECTION */}
                          {blogData.faq && blogData.faq.length > 0 && (
                            <Box mt={8}>
                              <Heading size="lg" mb={4}>FAQs</Heading>

                              <Accordion allowToggle>
                                {blogData.faq.map((item, index) => (
                                  <AccordionItem key={index} border="1px solid" borderColor="gray.200" rounded="md" mb={3}>
                                    <h2>
                                      <AccordionButton py={3}>
                                        <Box flex="1" textAlign="left" fontWeight="bold">
                                          {item.question}
                                        </Box>
                                        <AccordionIcon />
                                      </AccordionButton>
                                    </h2>

                                    <AccordionPanel pb={4} color="gray.600">
                                      {item.answer}
                                    </AccordionPanel>

                                  </AccordionItem>
                                ))}
                              </Accordion>
                            </Box>
                          )}
                          {/* DATE + TAGS */}
                          <HStack mt={5} spacing={4} wrap="wrap" display={'flex'} justifyContent={'space-between'}>
                            <Text display={'flex'} fontSize="sm">
                              <FiCalendar /> &nbsp;
                              {moment(blogData.createdAt).format('DD MMM YYYY')}
                            </Text>

                            <Text display={'flex'} gap={3} fontSize="sm" textTransform={'capitalize'}>
                              <Link to={blogData?.share_links?.facebook} target="_blank"> <FaFacebook className="fs-5" /></Link>
                              <Link to={blogData?.share_links?.whatsapp} target="_blank"><FaWhatsapp className="fs-5" /></Link>
                              <Link to={blogData?.share_links?.linkedin} target="_blank"> <FaLinkedin className="fs-5" /></Link>
                              <Link to={blogData?.share_links?.twitter} target="_blank">  <FaTwitter className="fs-5" /></Link>
                            </Text>
                          </HStack>

                        </Box>

                      </Box>
                    </GridItem>

                    {/* SIDEBAR */}
                    <GridItem>
                      <VStack align="stretch" spacing={6}>

                        {/* SEARCH */}
                        <Box bg={bg} p={4} rounded="lg" shadow="sm">
                          <Heading size="sm" mb={3}>Quick Search</Heading>
                          <Input placeholder="Search Here!" />
                        </Box>
                        <Box bg={bg} p={4} rounded="lg" shadow="sm">
                          <Heading size="sm" mb={3}>Tags</Heading>

                          <Wrap spacing={2}>
                            {blogData.tags && blogData.tags.length > 0 ? (
                              blogData.tags.map((tag, index) => (
                                <WrapItem key={index}>
                                  <Box
                                    px={3}
                                    py={1}
                                    fontSize="sm"
                                    bg="gray.200"
                                    color="gray.700"
                                    rounded="full"
                                    cursor="pointer"
                                    _hover={{ bg: "blue.500", color: "white" }}
                                    textTransform="capitalize"
                                  >
                                    {tag}
                                  </Box>
                                </WrapItem>
                              ))
                            ) : (
                              <Text fontSize="sm" color="gray.500">No tags available</Text>
                            )}
                          </Wrap>
                        </Box>
                        {/* RELATED POSTS */}
                        {/* <Box bg={bg} p={4} rounded="lg" shadow="sm">
                            <Heading size="sm" mb={3}>Related Posts</Heading>
                            <VStack align="start" spacing={3}>
                              {data.related.map((r) => (
                                <Link key={r.id} fontWeight="medium" color="blue.500">
                                  {r.title}
                                </Link>
                              ))}
                            </VStack>
                          </Box> */}

                      </VStack>
                    </GridItem>

                  </Grid>
                </Container>
              </Box>
            }

          </div>
        </section>
      </div>

    </>
  )
}

export default BlogDetail
